import { render, staticRenderFns } from "./CoursewareTalkBubble.vue?vue&type=template&id=50c879d6&"
import script from "./CoursewareTalkBubble.vue?vue&type=script&lang=js&"
export * from "./CoursewareTalkBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports